/* eslint-disable jsx-a11y/anchor-is-valid */
import { useMemo } from 'react';
import { Empty, Spin } from 'antd';
import { Link, useParams } from 'react-router-dom';
import styles from './FundingProgramDetails.module.scss';
import FundingSidebar from './components/SideBar/FundingSidebar.component';
import FundingMainContent from './components/MainContent/FundingMainContent.component';
import { useFundingProgramQuery } from 'pages/funding/hooks/useFundingProgramQuery';

export function FundingProgramDetails() {
  const { id } = useParams();
  const { data, isFetching, isError, error } = useFundingProgramQuery(id);

  const programDetails = data;

  const sections = useMemo(
    () => [
      { id: 'purpose', label: 'Σκοπός Προγράμματος' },
      { id: 'eligibility', label: 'Δικαιούχοι και Κριτήρια' },
      { id: 'expenses', label: 'Επιλέξιμες δαπάνες' },
      { id: 'financial', label: 'Χρηματοδοτικά στοιχεία' },
      { id: 'timeline', label: 'Προθεσμία' },
    //   { id: 'documents', label: 'Έγγραφα Προγράμματος' },
    ],
    []
  );

  const handleSectionClick = sectionId => {
    const el = document.getElementById(sectionId);
    if (!el) return;

    const yOffset = -16;
    const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;

    window.scrollTo({ top: y, behavior: 'smooth' });
  };

  return (
    <>
      {(!isFetching && programDetails) && (
        <div className={styles['funding-page-container']}>
          <div className={styles['header-details']}>
            <Link to="/fundingpage" className={styles['header-link']}>
              My Funding
            </Link>
            <span className={styles['header-separator']}>&gt;</span>
            <span className={styles['header-title']}>
              {programDetails?.title}
            </span>
          </div>
          <section className="main-container" id="main-content">
            <div className={styles['sidebar-wrapper']}>
              <FundingSidebar
                sections={sections}
                onSectionClick={handleSectionClick}
              />
            </div>
            <div className={styles['content-wrapper']} style={{marginBottom: 32}}>
              <FundingMainContent
                programDetails={programDetails}
              />
            </div>
          </section>
        </div>
      )}
    </>
  );
}